const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const SAFE_HREF = /^(https?:|mailto:)/i;

const anchor = (href: string, label: string): string =>
  `<a href="${href}" target="_blank" rel="noopener">${label}</a>`;

/**
 * Converts basic Slack mrkdwn to HTML for preview purposes.
 * Not pixel-perfect — just enough to catch formatting issues.
 *
 * The body is HTML-escaped before any mrkdwn is interpreted, so anything that is not mrkdwn
 * stays literal text, and only http, https and mailto links become anchors (PS-5792).
 */
export function mrkdwnToHtml(text: string): string {
  return (
    escapeHtml(text)
      // Bold: *text*
      .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
      // Italic: _text_
      .replace(/(?<!\w)_([^_]+)_(?!\w)/g, "<em>$1</em>")
      // Strikethrough: ~text~
      .replace(/~([^~]+)~/g, "<del>$1</del>")
      // Links: <url|text>, which after escaping reads &lt;url|text&gt;.
      // A URL never carries whitespace or the tags the passes above produced.
      .replace(/&lt;([^|\s<>]+?)\|(.+?)&gt;/g, (match, href, label) =>
        SAFE_HREF.test(href) ? anchor(href, label) : match,
      )
      // Plain links: <url>
      .replace(/&lt;(https?:\/\/[^\s<>]+?)&gt;/g, (_match, href) =>
        anchor(href, href),
      )
      // Line breaks
      .replace(/\n/g, "<br />")
  );
}
